module.exports = __webpack_public_path__ + "img/reid-college-logo.16c8238e.jpg";